// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material Files
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';

// Teller Online Files
import {
    AuthorizationConsentModule
} from 'apps/public-portal/src/app/shared/components/authorization-consent/authorization-consent.component';
import { PaymentConsentDialogComponent } from './payment-consent-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        MatLegacyDialogModule,
        MatLegacyButtonModule,
        AuthorizationConsentModule
    ],
    declarations: [PaymentConsentDialogComponent],
    exports: [PaymentConsentDialogComponent]
})
export class PaymentConsentDialogModule {}
